export default __webpack_public_path__ + "static/media/Long-COVID-Postcard2-8.5x5.5in-CC-BY-NC-SA.dfbf8fa3.pdf";